module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Molland Angus","short_name":"Molland Angus","start_url":"/","background_color":"#f7f2e8","theme_color":"#0b2530","display":"minimal-ui","icon":"src/images/hero-fjord-cow.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d054967d4964e019c3e31f63d0a5ff4c"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
